/**
 * Гарын авлагын хуудасны гарчгийн якорь.
 *
 * ! Хоёр тал ЭНЭ функцийг дуудна: API нь TOC-ийн `id`-г үүсгэхэд, панел нь
 * ! `<h2 id>`-г зурахад. Тусад нь хоёр хувилбар бичвэл кирилл галиглал, зай,
 * ! цэг таслалын аль нэг дээр зөрөөд «Энэ хуудсанд»-ын холбоос хаашаа ч
 * ! үсрэхгүй болно — алдаа нь чимээгүй, олоход хэцүү.
 *
 * Кирилл үсгийг ХЭВЭЭР үлдээнэ (URL fragment нь UTF-8 дэмждэг). Зөвхөн зайг
 * зураас болгож, бусад тэмдэгтийг хаяна.
 */
export const slugifyHeading = (text: string): string =>
  text
    .trim()
    .toLowerCase()
    // Markdown-ы үлдэгдэл: `код`, **тод**, [холбоос](зам)
    .replace(/`([^`]*)`/g, '$1')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/[*_~]/g, '')
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .replace(/\s+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '')

/**
 * Нэг гарчиг хоёр удаа давтагдвал якорь давхцана. Дараалсан дугаар нэмж
 * ялгана — GitHub-ын зан үйлтэй ижил (`гарчиг`, `гарчиг-1`, …).
 */
export const uniqueHeadingSlug = (text: string, seen: Map<string, number>): string => {
  const base = slugifyHeading(text) || 'heading'
  const count = seen.get(base) ?? 0

  seen.set(base, count + 1)

  return count === 0 ? base : `${base}-${count}`
}
